(function() {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .factory('SortableHelper', SortableHelper);

    SortableHelper.$inject = ['$window'];

    function SortableHelper($window) {
        /**
         * Controls scrolling while dragging and meant to be used with as-sortable sortListeners
         * and fullscreen-height elements. Scrolls container until it hits the max, then scrolls
         * the window.
         *
         * @param {Object} itemPosition - the item position.
         * @param {Object} containment - the containment element.
         * @param {Object} eventObj - the event object.
         */
        function dragMove(itemPosition, containment, eventObj) {
            if (eventObj) {
                /*
                 * How fast to scroll (in pixels)
                 */
                var scrollSpeedPx = 10;
                /*
                 * How far from the border to trigger scrolling (in pixels)
                 */
                var scrollThresholdAdjustmentPx = 100;
                var remainder;
                var containerComplex = angular.element('.fullscreen-height').not('.fullscreen-height-dependable');
                var container = containerComplex[0];

                var containerOffsetTop = containerComplex.offset().top;

                var cursorY = eventObj.pageY;
                var scrollThresholdTop = containerOffsetTop + scrollThresholdAdjustmentPx;
                var scrollThresholdBottom = (container.clientHeight + containerOffsetTop) - scrollThresholdAdjustmentPx;

                if (cursorY < scrollThresholdTop) {
                    if (container.scrollTop >= scrollSpeedPx) {
                        container.scrollTop = container.scrollTop - scrollSpeedPx;
                    }
                    else {
                        remainder = scrollSpeedPx - container.scrollTop;
                        $window.scrollBy(0, -remainder);
                    }
                }
                else if (cursorY > scrollThresholdBottom) {
                    var distanceFromBottom = (container.scrollHeight - container.offsetHeight) - container.scrollTop;

                    if (distanceFromBottom >= scrollSpeedPx) {
                        container.scrollTop = container.scrollTop + scrollSpeedPx;
                    }
                    else {
                        remainder = scrollSpeedPx - distanceFromBottom;
                        $window.scrollBy(0, remainder);
                    }
                }
            }
        }

        return {
            dragMove: dragMove
        };
    }
})();